"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _invitationType = require("../../store/gift/invitationType/invitationType.selectors");

var GiftMessageSubject = function GiftMessageSubject(_ref) {
  var subject = _ref.subject,
      error = _ref.error,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  var isEmailInvitation = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedEmailInvitationType);
  var label = isEmailInvitation ? 'Message subject (Used in initial email and all follow up emails)' : 'Message subject (Used in all follow up emails)';
  return /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    label: label,
    variant: "outlined",
    value: subject,
    error: !!error,
    helperText: error,
    onChange: onChange,
    disabled: disabled
  });
};

GiftMessageSubject.propTypes = {
  error: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  subject: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool
};
GiftMessageSubject.defaultProps = {
  disabled: false
};
var _default = GiftMessageSubject;
exports.default = _default;